import React from 'react';
import { Grid } from '@material-ui/core';

import ActiveStudentsChart from '../../charts/ActiveStudentsChart';
import OverallCurriculumProgressChart from '../../charts/OverallCurriculumProgressChart';
import ActivitiesCompletedAndTimeSpentChart from '../../charts/ActivitiesCompletedAndTimeSpentChart';
import AssessmentEnrichmentCards from '../../AssessmentEnrichmentCards';

const ClassroomOverrallCards: React.FC = () => {
  return (
    <>
      <section>
        <Grid container spacing={2} justify="center">
          <Grid item xs={6}>
            <OverallCurriculumProgressChart />
          </Grid>
          <Grid item xs={6}>
            <ActiveStudentsChart />
          </Grid>
        </Grid>
      </section>
      <ActivitiesCompletedAndTimeSpentChart />
      <AssessmentEnrichmentCards />
    </>
  );
};

export default ClassroomOverrallCards;
